module.exports = __webpack_public_path__ + "img/ship.be5030ca.webp";